import React, { useCallback, useState } from 'react';
import useModalRouter from '../../common/hooks/useModalRouter';
import { IonModal } from '@ionic/react';
import collect from 'collect.js';

const ModalRoute = (): JSX.Element | null => {
  const { config, isOpen, findModal, closeModal, dismissModal, goBack, openModal } = useModalRouter();
  const [showBackdrop, setShowBackdrop] = useState(true);

  const getModal = useCallback(() => {
    const modal = findModal(config?.id);
    if (!modal) return null;
    return modal.component;
  }, [config]);

  const modal = getModal();
  if (!modal) return null;

  return (
    <IonModal
      key={config.id}
      isOpen={isOpen}
      initialBreakpoint={config?.presentation?.initialBreakpoint}
      breakpoints={config?.presentation?.breakpoints}
      className={config?.presentation?.cssClass as string}
      onDidDismiss={() => {
        setShowBackdrop(true);
        dismissModal();
      }}
      onWillDismiss={() => setShowBackdrop(false)}
      showBackdrop={showBackdrop}
      backdropDismiss={true}
      style={{
        '--height': collect(config?.presentation).keys().isNotEmpty() ? 'auto' : '',
      }}
      onDidPresent={() => config?.onDidPresent?.()}
    >
      {React.createElement(modal, {
        openModal,
        goBack,
        closeModal,
        ...config?.props,
      })}
    </IonModal>
  );
};

export default ModalRoute;
